import { useMutation } from "@tanstack/react-query";
import { supabaseClient } from "../utils/supabase";
import { useAuth } from "./useAuth";

export function useOtpVerification() {
    const { setAuthData } = useAuth();

    return useMutation({
        mutationFn: async ({ phone, token }: { phone: string; token: string }) => {
            console.log("Starting OTP verification...", { phone, token });

            const { data, error } = await supabaseClient.auth.verifyOtp({
                phone,
                token,
                type: "sms",
            });

            console.log("Supabase verifyOtp response:", { data, error });

            if (error) {
                console.error("OTP verification error:", error);
                throw error;
            }

            if (!data.user) {
                console.warn("No user data in OTP verification response");
                throw new Error("No user data received");
            }

            return { user: data.user, phone };
        },
        onSuccess: async ({ user, phone }) => {
            console.log("OTP verification successful, setting user...");

            // Check admin status first
            try {
                const { data: adminData } = await supabaseClient
                    .from("profiles")
                    .select("is_admin")
                    .eq("profile_id", user.id)
                    .single();

                const isAdmin = adminData?.is_admin || false;
                setAuthData(user, { profile_id: user.id, phone, is_admin: isAdmin }, isAdmin);
            } catch (adminError) {
                console.error("Error checking admin status:", adminError);
                // Still set the user as authenticated even if admin check fails
                setAuthData(user, { profile_id: user.id, phone, is_admin: false }, false);
            }
        },
        onError: (error: any) => {
            console.error("OTP verification failed:", error);
        },
    });
}
